import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { AppThunk } from '../store'
import {
  getCompanyWeeklyTrackTime,
  patchCompanyWeeklyTrackTime,
} from '../../apis/setting'
import { setErrors } from '../common/errorsSlice'
import {
  companyWeeklyTrackTime,
  weeklyTrackTime,
} from '../../types/setting'

interface CompanyTrackTimeState {
  weeklyTrackTimes: weeklyTrackTime[]
  isLoading: boolean
}

const initialState:CompanyTrackTimeState = {
  weeklyTrackTimes: [],
  isLoading: true,
}

const companyWeeklyTrackTimeSlice = createSlice({
  name: 'company_weekly_track_time',
  initialState,
  reducers: {
    requestStart: (state) => {
      state.isLoading = true
      return state
    },
    getCompanyTrackTimeSuccess: (state, action: PayloadAction<companyWeeklyTrackTime>) => {
      state.weeklyTrackTimes = action.payload.weekly_track_times
      state.isLoading = false
      return state
    },
    updateCompanyWeeklyTrackTimeSuccess: (state, action: PayloadAction<companyWeeklyTrackTime>) => {
      state.weeklyTrackTimes = action.payload.weekly_track_times
      state.isLoading = false
      return state
    },
    requestFailure: (state) => {
      state.isLoading = false
      return state
    },
  },
})

export const {
  requestStart,
  getCompanyTrackTimeSuccess,
  updateCompanyWeeklyTrackTimeSuccess,
  requestFailure,
} = companyWeeklyTrackTimeSlice.actions

export const companyWeeklyTrackTimeReducer = companyWeeklyTrackTimeSlice.reducer

export const fetchCompanyWeeklyTrackTime = (): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getCompanyWeeklyTrackTime()
    .then((result) => dispatch(getCompanyTrackTimeSuccess(result)))
    .catch((error) => {
      dispatch(requestFailure())
      dispatch(setErrors(error))
    })
}

export const updateCompanyWeeklyTrackTime = (
  params: companyWeeklyTrackTime,
  callback: () => void,
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  patchCompanyWeeklyTrackTime(params)
    .then(() => {
      dispatch(updateCompanyWeeklyTrackTimeSuccess(params))
      callback()
    })
    .catch((error) => {
      dispatch(requestFailure())
      dispatch(setErrors(error))
    })
}
